var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-mails-template-editor.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-empty-placeholder.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/chemistry/elements/components/x-loader";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/forms/x-input.js";
import "@adornis/popover/x-dropdown-multiselection.js";
import "@adornis/popover/x-dropdown-selection.js";
import "@adornis/writer/x-tinymce.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { state } from "lit/decorators/state.js";
import "./x-mail-editor.js";
var XMailsTemplateEditor = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.getMailTemplates = async () => [];
    this.selectedMailType = "";
    this.selectedMailScope = "";
    this.mailTemplates = {};
  }
  async connectedCallback() {
    super.connectedCallback();
    const allTemplates = await this.getMailTemplates();
    this.mailTemplates = allTemplates.reduce((acc, template) => {
      const key = template.emailType;
      if (!acc[key])
        acc[key] = [];
      acc[key].push(template);
      return acc;
    }, {});
  }
  _getSelectedTemplate() {
    if (this.selectedMailType && this.selectedMailScope)
      return this.mailTemplates[this.selectedMailType]?.find((t) => t.scope === this.selectedMailScope);
    const templates = Object.entries(this.mailTemplates);
    const firstEntry = templates[0];
    if (templates.length === 1 && firstEntry)
      return firstEntry[1][0];
    return null;
  }
  render() {
    const selectedTemplate = this._getSelectedTemplate();
    return xComponents(html`
      <x-flex space="lg" h100>
        ${this._templateSelection()}
        ${selectedTemplate ? this.editSection(selectedTemplate) : html`
              <x-empty-placeholder .text=${"Kein Template ausgew\xE4hlt"} .img=${"mail"} no-wrapper></x-empty-placeholder>
            `}
      </x-flex>
    `);
  }
  _templateSelection() {
    const selectables = Object.keys(this.mailTemplates);
    if (selectables.length > 1)
      return xComponents(html`
        <x-flex horizontal space="sm">
          <x-dropdown-selection
            flex
            placeholder="Template auswählen"
            .value=${this.selectedMailType}
            .selectables=${selectables}
            .renderString=${(template) => template}
            @value-picked=${(e) => {
        this.selectedMailType = e.detail.value;
        if (!this.mailTemplates[e.detail.value]?.map((t) => t.scope).includes(this.selectedMailScope))
          this.selectedMailScope = this.mailTemplates[e.detail.value]?.[0]?.scope ?? "";
      }}
          ></x-dropdown-selection>
          <x-dropdown-selection
            flex
            placeholder="Scope auswählen"
            .value=${this.selectedMailScope}
            .selectables=${this.mailTemplates[this.selectedMailType]?.map((t) => t.scope) ?? []}
            .renderString=${(scope) => scope}
            @value-picked=${(e) => this.selectedMailScope = e.detail.value}
          ></x-dropdown-selection>
          ${this.sendTestMail ? html`
                <x-button
                  ?disabled=${!this.selectedMailType || !this.selectedMailScope}
                  @click=${() => this.sendTestMail?.(this.selectedMailType, this.selectedMailScope)}
                >
                  Sende Testmail an mich
                </x-button>
              ` : nothing}
        </x-flex>
        <x-hr></x-hr>
      `);
    return nothing;
  }
  editSection(selectedTemplate) {
    return xComponents(html`
      <x-mail-editor
        flex
        ?disabled=${this.disabled}
        .value=${selectedTemplate}
        ?clearable=${this.clearable}
        @delete=${() => {
      this.selectedMailType = "";
      this.selectedMailScope = "";
    }}
        ?footer=${this.footer}
        ?attachments=${this.attachments}
      ></x-mail-editor>
    `);
  }
};
__decorateClass([
  property({ attribute: false })
], XMailsTemplateEditor.prototype, "getMailTemplates", 2);
__decorateClass([
  property({ attribute: false })
], XMailsTemplateEditor.prototype, "sendTestMail", 2);
__decorateClass([
  property({ type: Boolean })
], XMailsTemplateEditor.prototype, "clearable", 2);
__decorateClass([
  property({ type: Boolean })
], XMailsTemplateEditor.prototype, "footer", 2);
__decorateClass([
  property({ type: Boolean })
], XMailsTemplateEditor.prototype, "attachments", 2);
__decorateClass([
  property({ type: Boolean })
], XMailsTemplateEditor.prototype, "disabled", 2);
__decorateClass([
  state()
], XMailsTemplateEditor.prototype, "selectedMailType", 2);
__decorateClass([
  state()
], XMailsTemplateEditor.prototype, "selectedMailScope", 2);
__decorateClass([
  state()
], XMailsTemplateEditor.prototype, "mailTemplates", 2);
XMailsTemplateEditor = __decorateClass([
  customElement("x-mails-template-editor")
], XMailsTemplateEditor);
export {
  XMailsTemplateEditor
};
